export default class ReadUrlsByRequest {
    #adult;
    #allowBought;
    #cfMax;
    #cfMin;
    #drMax;
    #drMin;
    #index;
    #keywordSearch;
    #keywordsCount;
    #lang;
    #positionMax;
    #positionMin;
    #priceMin;
    #priceMax;
    #rdMax;
    #rdMin;
    #source;
    #tfMax;
    #tfMin;
    #thematic;
    #thematicExcluded;
    #top;
    #type;
    #urlSearch;
    #url;
    #volume;
    #volumeMax;
    #volumeMin;
    #topTenCount;
    #orderBy;
    #sortBy;
    #page;
    #perPage;
    #total;
    #projectId;
    #partner;
    #siteAge;

    get adult() { return this.#adult; }
    set adult(value) { this.#adult = value; }

    get allowBought() { return this.#allowBought; }
    set allowBought(value) { this.#allowBought = value; }

    get cfMax() { return this.#cfMax; }
    set cfMax(value) { this.#cfMax = value; }

    get cfMin() { return this.#cfMin; }
    set cfMin(value) { this.#cfMin = value; }

    get drMax() { return this.#drMax; }
    set drMax(value) { this.#drMax = value; }

    get drMin() { return this.#drMin; }
    set drMin(value) { this.#drMin = value; }

    get index() { return this.#index; }
    set index(value) { this.#index = value; }

    get keywordSearch() { return this.#keywordSearch; }
    set keywordSearch(value) { this.#keywordSearch = value; }

    get keywordsCount() { return this.#keywordsCount; }
    set keywordsCount(value) { this.#keywordsCount = value; }

    get lang() { return this.#lang; }
    set lang(value) { this.#lang = value; }

    get positionMax() { return this.#positionMax; }
    set positionMax(value) { this.#positionMax = value; }

    get positionMin() { return this.#positionMin; }
    set positionMin(value) { this.#positionMin = value; }

    get priceMin() { return this.#priceMin; }
    set priceMin(value) { this.#priceMin = value; }

    get priceMax() { return this.#priceMax; }
    set priceMax(value) { this.#priceMax = value; }

    get rdMax() { return this.#rdMax; }
    set rdMax(value) { this.#rdMax = value; }

    get rdMin() { return this.#rdMin; }
    set rdMin(value) { this.#rdMin = value; }

    get source() { return this.#source; }
    set source(value) { this.#source = value; }

    get tfMax() { return this.#tfMax; }
    set tfMax(value) { this.#tfMax = value; }

    get tfMin() { return this.#tfMin; }
    set tfMin(value) { this.#tfMin = value; }

    get thematic() { return this.#thematic; }
    set thematic(value) { this.#thematic = value; }

    get thematicExcluded() { return this.#thematicExcluded; }
    set thematicExcluded(value) { this.#thematicExcluded = value; }

    get top() { return this.#top; }
    set top(value) { this.#top = value; }

    get type() { return this.#type; }
    set type(value) { this.#type = value; }

    get urlSearch() { return this.#urlSearch; }
    set urlSearch(value) { this.#urlSearch = value; }

    get url() { return this.#url; }
    set url(value) { this.#url = value; }

    get volume() { return this.#volume; }
    set volume(value) { this.#volume = value; }

    get volumeMax() { return this.#volumeMax; }
    set volumeMax(value) { this.#volumeMax = value; }

    get volumeMin() { return this.#volumeMin; }
    set volumeMin(value) { this.#volumeMin = value; }

    get topTenCount() { return this.#topTenCount; }
    set topTenCount(value) { this.#topTenCount = value; }

    get orderBy() { return this.#orderBy; }
    set orderBy(value) { this.#orderBy = value; }

    get sortBy() { return this.#sortBy; }
    set sortBy(value) { this.#sortBy = value; }

    get page() { return this.#page; }
    set page(value) { this.#page = value; }

    get perPage() { return this.#perPage; }
    set perPage(value) { this.#perPage = value; }

    get total() { return this.#total; }
    set total(value) { this.#total = value; }

    get projectId() { return this.#projectId; }
    set projectId(value) { this.#projectId = value; }

    get partner() { return this.#partner; }
    set partner(value) { this.#partner = value; }

    get siteAge() { return this.#siteAge; }
    set siteAge(value) { this.#siteAge = value; }

    static fromParams(params, meta, projectId) {
        const readUrlsByRequest = new ReadUrlsByRequest()

        readUrlsByRequest.adult = params.adult
        readUrlsByRequest.allowBought = params.allowBought
        readUrlsByRequest.cfMax = params.cf_max ?? null
        readUrlsByRequest.cfMin = params.cf_min ?? null
        readUrlsByRequest.drMax = params.dr_max ?? null
        readUrlsByRequest.drMin = params.dr_min ?? null
        readUrlsByRequest.index = params.index ?? null
        readUrlsByRequest.keywordSearch = params.keywordSearch ?? null
        readUrlsByRequest.keywordsCount = params.keywordsCount ?? null
        readUrlsByRequest.lang = params.lang
        readUrlsByRequest.positionMax = params.positionMax
        readUrlsByRequest.positionMin = params.positionMin
        readUrlsByRequest.priceMin = params.price_min ?? null
        readUrlsByRequest.priceMax = params.price_max ?? null
        readUrlsByRequest.rdMax = params.rd_max ?? null
        readUrlsByRequest.rdMin = params.rd_min ?? null
        readUrlsByRequest.source = params.source ?? null
        readUrlsByRequest.tfMax = params.tf_max ?? null
        readUrlsByRequest.tfMin = params.tf_min ?? null
        readUrlsByRequest.thematic = params.thematic ?? null
        readUrlsByRequest.thematicExcluded = params.thematicExcluded ?? null
        readUrlsByRequest.top = params.top ?? null
        readUrlsByRequest.type = params.type ?? null
        readUrlsByRequest.urlSearch = params.urlSearch ?? null
        readUrlsByRequest.url = params.url ?? null
        readUrlsByRequest.volume = params.volume ?? null
        readUrlsByRequest.volumeMax = params.volumeMax ?? null
        readUrlsByRequest.volumeMin = params.volumeMin
        readUrlsByRequest.topTenCount = params.topTenCount ?? null
        readUrlsByRequest.orderBy = meta.orderBy
        readUrlsByRequest.sortBy = meta.sortBy
        readUrlsByRequest.page = meta.page
        readUrlsByRequest.perPage = meta.perPage
        readUrlsByRequest.total = meta.total
        readUrlsByRequest.projectId = projectId
        readUrlsByRequest.partner = params.partner ?? null
        readUrlsByRequest.siteAge = params.siteAge ?? null

        return readUrlsByRequest
    }

    toJson() {
        return {
            adult: this.adult,
            allowBought: this.allowBought,
            cf_max: this.cfMax,
            cf_min: this.cfMin,
            dr_max: this.drMax,
            dr_min: this.drMin,
            index: this.index,
            keywordSearch: this.keywordSearch,
            keywordsCount: this.keywordsCount,
            lang: this.lang,
            positionMax: this.positionMax,
            positionMin: this.positionMin,
            price_min: this.priceMin,
            price_max: this.priceMax,
            rd_max: this.rdMax,
            rd_min: this.rdMin,
            source: this.source,
            tf_max: this.tfMax,
            tf_min: this.tfMin,
            thematic: this.thematic,
            thematicExcluded: this.thematicExcluded,
            top: this.top,
            type: this.type,
            urlSearch: this.urlSearch,
            url: this.url,
            volume: this.volume,
            volumeMax: this.volumeMax,
            volumeMin: this.volumeMin,
            topTenCount: this.topTenCount,
            orderBy: this.orderBy,
            sortBy: this.sortBy,
            page: this.page,
            "per-page": this.perPage,
            total: this.total,
            projectId: this.projectId,
            partner: this.partner,
            siteAge: this.siteAge,
        };
    }
}
